/* eslint-disable i18next/no-literal-string */
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';

interface SearchTabsProps {
  tabValue: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const SearchTabs = ({ tabValue, handleTabChange }: SearchTabsProps) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="search-tabs-container"
      sx={{
        mb: 2,
        width: '100%',
        maxWidth: '400px',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <Box
        data-testid="search-tabs-background"
        sx={{
          position: 'absolute',
          width: '100%',
          height: '48px',
          borderRadius: '16px',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          backdropFilter: 'blur(8px)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
          zIndex: 0,
        }}
      />

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="search tabs"
        variant="fullWidth"
        data-testid="search-tabs"
        sx={{
          minHeight: '48px',
          position: 'relative',
          zIndex: 1,
          width: '100%',
          '& .MuiTabs-flexContainer': {
            height: '48px',
          },
          '& .MuiTabs-indicator': {
            height: '100%',
            borderRadius: '16px',
            backgroundColor: theme.palette.background.paper,
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            zIndex: -1,
          },
        }}
      >
        <Tab
          icon={<PersonIcon fontSize="small" />}
          iconPosition="start"
          label="Staff"
          id="tab-0"
          aria-controls="tabpanel-0"
          data-testid="staff-tab"
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.95rem',
            minHeight: '48px',
            zIndex: 2,
            color:
              tabValue === 0
                ? theme.palette.primary.main
                : alpha(theme.palette.text.primary, 0.6),
            '&.Mui-selected': {
              color: theme.palette.primary.main,
              fontWeight: 600,
            },
          }}
        />
        <Tab
          icon={<GroupsIcon fontSize="small" />}
          iconPosition="start"
          label="Teams"
          id="tab-1"
          aria-controls="tabpanel-1"
          disabled
          data-testid="teams-tab"
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.95rem',
            minHeight: '48px',
            zIndex: 2,
            opacity: 0.5,
            color: alpha(theme.palette.text.primary, 0.6),
            '&.Mui-selected': {
              color: theme.palette.primary.main,
              fontWeight: 600,
            },
          }}
        />
      </Tabs>
    </Box>
  );
};

export default SearchTabs;
